import { fromJS, Map, List } from 'immutable';
const NAME_SPACE = 'STATISTICS/';
const initialData = Map({
  loading: false,
  updateTime: null,
  individual: Map({
    loading: false,
    title: '',
    count: 0,
    profit: 0,
    transaction_amount: 0,
    refund_fee: 0,
    data: List([]),
    products: List([]),
    province: List([]),
  }),
  summary: Map({
    loading: false,
    pageSize: 0,
    currentPage: 0,
    count: 0,
    data: List([]),
  }),
  dashboard: Map({
    overview: Map({
      today: Map({}),
      tomonth: Map({}),
      dayrefund: Map({}),
      monthrefund: Map({}),
    }),
    platform: Map({
      today: List([]),
      tomonth: List([]),
    }),
    rank: Map({
      sales: List([]),
      products: List([]),
      destination: List([]),
    }),
    range: List([]),
    day: List([]),
    year: Map({
      loading: false,
      sales: Map({
        data: List([]),
      }),
      products: Map({
        data: List([]),
      }),
      diff: List([]),
      byDate: List([]),
      dateTime: '',
    }),
    refund: List([]),
    customer: Map({
      ageData: List([]),
      desData: Map({
        provinceData: List([]),
      }),
      sourceData: Map({
        cityData: List([]),
        provinceData: List([]),
      }),
    }),
  }),
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return initialData;
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', (loading) => action.payload.state);
    case NAME_SPACE + 'RES_UPDATE':
      return state.update('updateTime', (updateTime) => action.payload);
    case NAME_SPACE + 'RECEIVE_STATISTICS_DATA':
      return state.update('summary', (s) => fromJS(action.payload));
    case NAME_SPACE + 'RECEIVE_INDIVIDUAL_DATA':
      return state.update('individual', (obj) => fromJS(action.payload));
    case NAME_SPACE + 'RECEIVE_DASHBOARD_OVERVIEW_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('overview', (data) => fromJS(action.payload));
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_PLATFORM_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('platform', (data) => fromJS(action.payload));
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_RANK_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('rank', (data) => fromJS(action.payload));
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_RANGE_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('range', (data) => fromJS(action.payload));
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_DAY_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('day', (day) => fromJS(action.payload));
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_YEAR_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('year', (year) => fromJS(action.payload));
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_REFUND_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('refund', (refund) => fromJS(action.payload));
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_MAP_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('customer', (obj) => {
          return obj.update('sourceData', (mapData) => fromJS(action.payload));
        });
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_AGE_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('customer', (obj) => {
          return obj.update('ageData', (data) => fromJS(action.payload));
        });
      });
    case NAME_SPACE + 'RECEIVE_DASHBOARD_DESTINATION_DATA':
      return state.update('dashboard', (dashboard) => {
        return dashboard.update('customer', (obj) => {
          return obj.update('desData', (data) => fromJS(action.payload));
        });
      });
    default:
      return state;
  }
};

const Statistics = (state = initialData, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return item(undefined, action);
    case NAME_SPACE + 'V_LOADING':
    case NAME_SPACE + 'RES_UPDATE':
    case NAME_SPACE + 'RECEIVE_STATISTICS_DATA':
    case NAME_SPACE + 'RECEIVE_INDIVIDUAL_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_OVERVIEW_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_PLATFORM_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_RANK_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_RANGE_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_DAY_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_YEAR_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_REFUND_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_MAP_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_AGE_DATA':
    case NAME_SPACE + 'RECEIVE_DASHBOARD_DESTINATION_DATA':
      return item(state, action);
    default:
      return state;
  }
};

export default Statistics;
